module.exports = __webpack_public_path__ + "media/images/service-4-c6be5f1cc88ef2c6eab5040241c63a28.png";